import packageJson from '../package.json';

export const pkgName =  packageJson.name;
export const customerPckgName = 'customer-search-widget';
